import { render, staticRenderFns } from "./SearchTabs.vue?vue&type=template&id=073cf551&scoped=true&"
import script from "./SearchTabs.vue?vue&type=script&lang=js&"
export * from "./SearchTabs.vue?vue&type=script&lang=js&"
import style0 from "./SearchTabs.vue?vue&type=style&index=0&id=073cf551&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073cf551",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('073cf551')) {
      api.createRecord('073cf551', component.options)
    } else {
      api.reload('073cf551', component.options)
    }
    module.hot.accept("./SearchTabs.vue?vue&type=template&id=073cf551&scoped=true&", function () {
      api.rerender('073cf551', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/search/components/SearchTabs.vue"
export default component.exports